import {useState, useCallback, useEffect} from 'react';
import * as aircoreMedia from '@aircore/aircore-media';
import {v4 as uuid4} from 'uuid';
import {VIDEO_STYLE, VIDEO_STYLE_MIRRORED} from './styles';
import {VideoCameraSlashIcon} from '@heroicons/react/20/solid';

interface VideoProps {
  source: aircoreMedia.VideoRenderer;
  isMuted: boolean;
  isMirrored?: boolean;
}

export function Video({source, isMuted, isMirrored = false}: VideoProps) {
  const [isEnabled, setIsEnabled] = useState(true);
  const [elementId] = useState(uuid4());

  useEffect(() => {
    if (isEnabled) {
      void source.addRenderTarget(elementId);
    } else {
      source.removeRenderTarget(elementId);
    }
  }, [isEnabled]);

  const handleVideoToggle = useCallback(() => {
    setIsEnabled(prev => !prev);
  }, []);

  // QA wants to see properly sized videos, no stretching or cropping, so use a square container which will allow edges to be seen for non-square videos
  // Note, the "-scale-x-100" is how we meet the requirement of mirroring the video
  const style = isMirrored ? VIDEO_STYLE_MIRRORED : VIDEO_STYLE;
  return (
    <>
      {isMuted && <VideoCameraSlashIcon className="h-32 sm:h-64 text-red-500 p-1" />}
      <video playsInline autoPlay className={style} id={elementId} onClick={handleVideoToggle} hidden={isMuted} />
    </>
  );
}
